'use client'

import debug from 'debug'
import { FC, useMemo } from 'react'
import { getPublicEnv } from '@tucan/utils'
import { isBrowser } from 'utils/is.browser'

interface Props {
  env: Record<string, string | undefined>
}

export const EnvProviderClient: FC<Props> = ({ env }) => {
  useMemo(() => {
    if (isBrowser()) {
      globalThis.env = env
      window.dispatchEvent(new Event('process.env'))
    }

    debug.enable(getPublicEnv('DEBUG') ?? '')
  }, [])

  return null
}
